import { ReactNode } from "react";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { useTranslation } from "@coworker/locales";

type MenuSheetProps = {
  visible: boolean;
  onCloseClick: () => void;
  children: ReactNode;
};

function MenuSheet({ visible, onCloseClick, children }: MenuSheetProps) {
  const { t } = useTranslation();
  return (
    <FixaModal visible={visible} handleCloseBtn={onCloseClick}>
      <FixaSheets
        ariaLabel={t("taskActionsString")}
        header={<FixaModalHeader closeBtnClick={onCloseClick} />}
        footer={null}
        fullSize
      >
        <FixaModalBody>
          <FixaListView size="small" id="menu-items">
            {children}
          </FixaListView>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
}

export default MenuSheet;
